export const RouterChecker = (_route) => {
	if(window.location.pathname === _route) return true
    return false
}
